import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'dsh-actions',
    templateUrl: 'actions.component.html',
    styleUrls: ['actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionsComponent {}
